import { IconFileTypePdf } from '@tabler/icons-react';

const SIZES = {
    xs: { icon: 26, name: 'text-[9px]', detail: 'text-[9px]', pad: 'px-1' }, // the Photo Booth queue's small tiles
    sm: { icon: 32, name: 'text-[11px]', detail: 'text-[10px]', pad: 'p-2' }, // a tile in the customer's list of what they are sending
    lg: { icon: 52, name: 'text-sm', detail: 'text-xs', pad: 'p-2' }, // a single file shown big
};

/**
 * A PDF's stand-in for a picture: a document card with its name and one detail line (pages / size), sized to whatever tile holds it.
 * It fills its parent — the parent decides the shape.
 */
export default function BoothPdfFace({ name, detail, size = 'sm' }) {
    const s = SIZES[size] || SIZES.sm;
    return (
        <span className={`flex h-full w-full flex-col items-center justify-center gap-1.5 bg-red-50 text-center dark:bg-red-950/30 ${s.pad}`}>
            <IconFileTypePdf size={s.icon} stroke={1.5} className="text-red-500" />
            <span className={`line-clamp-2 w-full break-words font-semibold leading-tight text-zinc-700 dark:text-zinc-200 ${s.name}`}>{name}</span>
            {detail ? <span className={`leading-none text-zinc-500 dark:text-zinc-400 ${s.detail}`}>{detail}</span> : null}
        </span>
    );
}
